import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import {
  CheckOut,
  CheckOutFailure,
  CheckOutFeatureActionTypes,
  CheckOutSuccess,
} from './check-in-kiosk-feature-check-out.actions';
import { getCheckOutWorkflowId } from './check-in-kiosk-feature-check-out.selectors';
import { CheckInKioskFeatureCheckOutService } from './check-in-kiosk-feature-check-out.service';

@Injectable()
export class CheckInKioskFeatureCheckOutEffects {
  checkOut$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckOutFeatureActionTypes.CheckOut),
      withLatestFrom(this.store.pipe(select(getCheckOutWorkflowId))),
      mergeMap(([{ payload }, workflowId]: [CheckOut, any]) =>
        this.srv.checkOut(payload.tag, workflowId).pipe(
          map(() => new CheckOutSuccess()),
          catchError((error) => of(new CheckOutFailure(error)))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<any>,
    private srv: CheckInKioskFeatureCheckOutService
  ) {}
}
